import {Injectable, NgZone, TemplateRef, ViewContainerRef} from '@angular/core';
import {DialogHelperInterface} from '~/app/shared/helpers/dialog-helper-interface';
import {
    AddItemsDialogComponent,
    InventoryAddModel
} from '~/app/web/components/add-items-dialog/add-items-dialog.component';
import {DialogAction, DialogRef, DialogService,ActionsLayout} from '@progress/kendo-angular-dialog';
import {Router} from '@angular/router';
import {PartialdialogComponent} from '~/app/web/components/partialdialog/partialdialog.component';
import {MatDialog} from '@angular/material/dialog';
import {StorelistDialogComponent} from '~/app/web/components/storelist-dialog/storelist-dialog.component';
import {NotificationsComponent} from '~/app/web/components/notifications/notifications.component';
import {
    EnvironmentChangeDialogComponent
} from '~/app/web/components/environment-change-dialog/environment-change-dialog.component';
import {BaseService} from '~/app/core/common/services/base.service';
import {ApiService} from '~/app/core/common/services/api.service';
import {NoStoresDialogComponent} from '~/app/shared/no-stores-dialog/no-stores-dialog.component';
import {InvoicelistDialogComponent} from "~/app/web/components/invoicelist-dialog/invoicelist-dialog.component";
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DialogHelperComponent implements DialogHelperInterface {

    constructor(
                public dialogService: DialogService,
                public dialog: MatDialog,
                public router: Router,
                public baseService: BaseService,
                public apiService: ApiService,
                private zone: NgZone) {
    }

    async open(options): Promise<string> {
        const dialog: DialogRef = this.dialogService.open(options as DialogSettings);
        dialog.dialog.location.nativeElement.classList.add(options.type);
        const results = await firstValueFrom(dialog.result).then(response => response as DialogAction);
        return results.text;
    }

    async showOrderUploadDialog(dialog: any, inventoryItem: any): Promise<any> {
        (dialog as PartialdialogComponent).open(DialogType.INFO,
            'Partial Search',
            '',
            'Cancel',
            'Ok',
            0,
            0,
            0,
            0,
            inventoryItem)
            .then((value) => {
                return value;
            });
    }

    async showPartialDialog(dialog: any, inventoryItem: any): Promise<any> {
        return await (dialog as PartialdialogComponent).open(DialogType.INFO,
            'Partial Search',
            '',
            'Cancel',
            'Ok',
            0,
            0,
            0,
            0,
            inventoryItem)


    }

    async showStoreDialog(tempRef: any, dialog: any, storeList: any): Promise<any> {
        (dialog as StorelistDialogComponent).open(DialogType.INFO,
            'Please Select a Store',
            '',
            'Cancel',
            'Ok',
            0,
            400,
            0,
            0,
            storeList)
            .then((value) => {
                tempRef.ReloadDataPage();
                return value;
            });
    }

    async showInvoiceDialog(tempRef: any, dialog: any, list: any): Promise<any> {
        (dialog as InvoicelistDialogComponent).open(
            DialogType.INFO,
            'Please Select an Invoice',
            '',
            'Cancel',
            'Ok',
            0,
            600,
            0,
            0,
            list)
            .then((value) => {
                return value;
            });
    }

    async showNotificationDialog(dialog: any): Promise<any> {
        (dialog as NotificationsComponent).open(DialogType.INFO, 'Notifications').then((value => {
            return;
        }));
    }

    async showEnvironmentChangeWebDialog(dialog: any): Promise<any> {
        return (dialog as EnvironmentChangeDialogComponent).open(DialogType.INFO,
            'Environment Change',
            '',
            'Cancel',
            'Ok',
            0,
            0,
            0,
            0);
    }

    async showEnvironmentChangeMobileDialog(title: string, message: string) {
    }

    async showConfirmDialogYesNo(title: string, message: string): Promise<boolean> {
        const dialog: DialogRef = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [
                {text: 'No'},
                {text: 'Yes', themeColor:"primary"},
            ]
        });

        dialog.dialog.location.nativeElement.classList.add(DialogType.QUESTION);
        const results = await dialog.result.toPromise().then(response => response as DialogAction);
        return results.text === 'Yes';
    }

    async showConfirmDialogOkCancel(title: string, message: string): Promise<boolean> {

        const dialog: DialogRef = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [
                {text: 'Cancel'},
                {text: 'Ok', themeColor:"primary"},
            ]
        });

        dialog.dialog.location.nativeElement.classList.add(DialogType.QUESTION);
        const results = await dialog.result.toPromise().then(response => response as DialogAction);
        return results.text === 'Ok';
    }

    async showConfirmDialogOkOnly(title: string, message: string): Promise<boolean> {
        const dialog: DialogRef = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [
                {text: 'Ok', themeColor:"primary"},
            ]
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.QUESTION);
        const results = await dialog.result.toPromise().then(response => response as DialogAction);
        return results.text === 'Ok';
    }

    async showOkErrorDialog(title: string, message: string): Promise<boolean> {
        const dialog: DialogRef = this.dialogService.open({
            title: title,
            content: message,
            width: 400,
            actions: [
                {text: 'Ok', themeColor:"primary"},
            ]
        });
        dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
        const results = await dialog.result.toPromise().then(response => response as DialogAction);
        return results.text === 'Ok';
    }

    async showNoStoresDialog(): Promise<boolean> {
        return await this.zone.run(async () => {
            const dialog: DialogRef = this.dialogService.open({
                title: 'Unexpected Error!',
                content: NoStoresDialogComponent,
                width: 400,
                actions: [
                    {text: 'Ok', themeColor:"primary"},
                ]
            });
            dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
            const results = await dialog.result.toPromise().then(response => response as DialogAction);
            return results.text === 'Ok';
        });
    }

   
    async showRetryDialog(): Promise<any> {
        const dialog: DialogRef = this.dialogService.open({
            title: 'Oops!',
            content: 'Sorry, Something happened on our end. Please retry your request.',
            width: 400,
            actions: [
                {text: 'Ok', themeColor:"primary"},
            ]
        });

        dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
        const results = await dialog.result.toPromise().then(response => response as DialogAction);
        return results.text === 'Ok';

        // dialog.dialog.location.nativeElement.classList.add(DialogType.ERROR);
        // dialog.result.toPromise().then(results => {
        //     if (results === 'Ok') {
        //         this.router.navigate(['/logout']).then(r => r);
        //     }
        // });
    }

    showInventoryAddItems(): Promise<any> {
        const dialogData = new InventoryAddModel('Add Items');
        const partialBox = this.dialog.open(AddItemsDialogComponent, {
            data: dialogData
        });
        return partialBox.afterClosed().toPromise().then((result) => {
            return result;
        });
    }

    isInternetAvailable() {
        return true;
    }

}

export enum DialogType {
    INFO = 'infoDialog',
    QUESTION = 'questionDialog',
    WARNING = 'warningDialog',
    ERROR = 'errorDialog'
}

export declare class DialogSettings {
    /**
     * Sets the title of the Dialog. If `title` is omitted,
     * the Dialog will not render a **Close** button.
     */
    type?: string;
    /**
     * Sets the title of the Dialog. If `title` is omitted,
     * the Dialog will not render a **Close** button.
     */
    title?: string;
    /**
     * Defines the content of the Dialog.
     * ([see example]({% slug service_dialog %}#toc-using-components)).
     */
    content?: string | TemplateRef<any> | Function;
    /**
     * Specifies the width of the Dialog.
     * A numeric value sets the width in pixels.
     * A string value sets the width in arbitrary units&mdash;for example, `50%`.
     */
    width?: number | string;
    /**
     * Specifies the minimum width of the Dialog.
     * A numeric value sets the minimum width in pixels.
     * A string value sets the minimum width in arbitrary units&mdash;for example, `50%`.
     */
    minWidth?: number | string;
    /**
     * Specifies the maximum width of the Dialog.
     * A numeric value sets the maximum width in pixels.
     * A string value sets the maximum width in arbitrary units&mdash;for example, `50%`.
     */
    maxWidth?: number | string;
    /**
     * Specifies the height of the Dialog.
     * A numeric value sets the height in pixels.
     * A string value sets the height in arbitrary units&mdash;for example, `50%`.
     */
    height?: number | string;
    /**
     * Specifies the minimum height of the Dialog.
     * A numeric value sets the minimum height in pixels.
     * A string value sets the minimum height in arbitrary units&mdash;for example, `50%`.
     */
    minHeight?: number | string;
    /**
     * Specifies the maximum height of the Dialog.
     * A numeric value sets the maximum height in pixels.
     * A string value sets the maximum height in arbitrary units&mdash;for example, `50%`.
     */
    maxHeight?: number | string;
    /**
     * Defines the container in which the Dialog will be inserted.
     * Specifying this option changes the place in the page hierarchy where the Dialog will be inserted.
     * The styling of the component will remain the same.
     */
    appendTo?: ViewContainerRef;
    /**
     * Specifies the title of the close button.
     */
    closeTitle?: string;
    /**
     * Sets the action buttons of the Dialog.
     */
    actions?: DialogAction[] | any[] | TemplateRef<any>;
    /**
     * Specifies the layout of the action buttons in the Dialog.
     */
    actionsLayout?: ActionsLayout;
    /**
     * Sets the focused element query selector.
     */
    autoFocusedElement?: string;
}
